import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'RatingItemSport',
    props: {
        card: {
            default: () => ({}),
            type: Object,
        },
        head: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Columns
         */
        const columns = computed(() => {
            return Object.entries(props.card.columns).reduce((columns, [key, value], i) => {
                const column = {
                    key,
                    tag: 'span',
                    value,
                };
                if (i === 0 && key !== '$name') {
                    column.key = '#';
                    column.tag = 'div';
                }
                else if (key === '$name') {
                    column.tag = 'div';
                }
                else {
                    const [prefix, v] = value.split(' ');
                    column.prefix = prefix;
                    column.value = v;
                }
                columns[key] = column;
                return columns;
            }, {});
        });
        return {
            css,
            columns,
        };
    },
});
